/**
 * Custom theme JavaScript (no jQuery — not loaded in this theme).
 */

window.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('shopify:section:load', function () {
    console.log('event fired - doc');
  });

  // For Mobile View: close open collapsibles
  setTimeout(function () {
    if (window.outerWidth < 767) {
      document.querySelectorAll('collapsible-content[open]').forEach(function (el) {
        el.removeAttribute('open');
      });
    }
  }, 1000);

  // Add link to last gallery slide on homepage
  setTimeout(function () {
    var figure = document.querySelector('.gallery__item:last-child > .gallery__figure');
    if (figure && figure.parentElement && figure.parentElement.tagName !== 'A') {
      var link = document.createElement('a');
      link.href = '/pages/our-story';
      figure.parentNode.insertBefore(link, figure);
      link.appendChild(figure);
    }
  }, 1000);

  // Add Read More to Collection Page
  setTimeout(function () {
    var carLmt = 300;
    var readMoreTxt = ' ...read more';
    var readLessTxt = ' read less';

    document.querySelectorAll('.add-read-more').forEach(function (el) {
      if (el.querySelector('.first-section')) return;

      var allstr = el.textContent || '';
      if (allstr.length <= carLmt) return;

      var firstSet = allstr.substring(0, carLmt);
      var secdHalf = allstr.substring(carLmt);
      el.innerHTML =
        firstSet +
        "<span class='second-section'>" +
        secdHalf +
        "</span><span class='read-more' title='Click to Show More'>" +
        readMoreTxt +
        "</span><span class='read-less' title='Click to Show Less'>" +
        readLessTxt +
        '</span>';
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.read-more, .read-less');
      if (!trigger) return;
      var container = trigger.closest('.add-read-more');
      if (!container) return;
      container.classList.toggle('show-less-content');
      container.classList.toggle('show-more-content');
    });
  }, 1000);
});
